"use client";

import { ManualPropertyAdditionDialog } from "@/components/app/properties/manual/manual-property-addition-dialog";
import { useJourneyData } from "@/hooks/use-journey-data";
import { useState } from "react";
import { PropertyInputForm } from "./property-input-form";

export interface AddPropertyComponentProps {
  defaultPropertyUrl?: string;
}

export function AddPropertyComponent({
  defaultPropertyUrl,
}: AddPropertyComponentProps) {
  const { createProperty } = useJourneyData();

  const [manualPropertyAdditionModalOpen, setManualPropertyAdditionModalOpen] =
    useState(false);

  const handleSubmit = async (data: { url: string }) => {
    await createProperty.mutateAsync(data.url);
  };

  return (
    <>
      <PropertyInputForm
        onSubmit={handleSubmit}
        onManualAdd={() => setManualPropertyAdditionModalOpen(true)}
        defaultPropertyUrl={defaultPropertyUrl}
      />

      <ManualPropertyAdditionDialog
        open={manualPropertyAdditionModalOpen}
        onOpenChange={setManualPropertyAdditionModalOpen}
      />
    </>
  );
}
